/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Author_ArtistInputs */

const en_field_author_artist = /** @type {(inputs: Field_Author_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Author / Artist`)
};

const es_field_author_artist = /** @type {(inputs: Field_Author_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autor / Artista`)
};

const fr_field_author_artist = /** @type {(inputs: Field_Author_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auteur / Artiste`)
};

const de_field_author_artist = /** @type {(inputs: Field_Author_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autor / Künstler`)
};

const ja_field_author_artist = /** @type {(inputs: Field_Author_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`著者 / アーティスト`)
};

const zh_field_author_artist = /** @type {(inputs: Field_Author_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作者 / 艺术家`)
};

const ar_field_author_artist = /** @type {(inputs: Field_Author_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المؤلف / الفنان`)
};

const id_field_author_artist = /** @type {(inputs: Field_Author_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penulis / Seniman`)
};

const it_field_author_artist = /** @type {(inputs: Field_Author_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autore / Artista`)
};

const ru_field_author_artist = /** @type {(inputs: Field_Author_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автор / Исполнитель`)
};

const pt_field_author_artist = /** @type {(inputs: Field_Author_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autor / Artista`)
};

const ko_field_author_artist = /** @type {(inputs: Field_Author_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저자 / 아티스트`)
};

/**
* | output |
* | --- |
* | "Author / Artist" |
*
* @param {Field_Author_ArtistInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_author_artist = /** @type {((inputs?: Field_Author_ArtistInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Author_ArtistInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_author_artist(inputs)
	if (locale === "es") return es_field_author_artist(inputs)
	if (locale === "fr") return fr_field_author_artist(inputs)
	if (locale === "de") return de_field_author_artist(inputs)
	if (locale === "ja") return ja_field_author_artist(inputs)
	if (locale === "zh") return zh_field_author_artist(inputs)
	if (locale === "ar") return ar_field_author_artist(inputs)
	if (locale === "id") return id_field_author_artist(inputs)
	if (locale === "it") return it_field_author_artist(inputs)
	if (locale === "ru") return ru_field_author_artist(inputs)
	if (locale === "pt") return pt_field_author_artist(inputs)
	return ko_field_author_artist(inputs)
});